import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import Logo from '../assets/images/gym logo.png'

const Footer = () => {
  return (
    <Box mt="80px" bgcolor='#fff3f4'>
      <Stack sx={{background : '#fff'}} gap='10px' alignItems='center' px='40px' pt='24px'>
        <img  width='60px' height='60px' src={Logo} alt="" />
        <Typography variant='h5' pb='40px' mt='10px'>
          Made with ❤️ by Rishabh Dhiman
        </Typography>
      </Stack>
      </Box>
  )
}

export default Footer